import React from "react";
import "./menu.scss";

export default function menu({ menuOpen, setMenuOpen }) {
  return (
    <>
      <div className={`${menuOpen ? "menu active" : "menu"}`}>
        <ul>
          <li>
            <a
              href="#intro"
              onClick={() => {
                setMenuOpen(!menuOpen);
              }}
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="#newportfolio"
              onClick={() => {
                setMenuOpen(!menuOpen);
              }}
            >
              Portfolio
            </a>
          </li>
          <li>
            <a
              href="#works"
              onClick={() => {
                setMenuOpen(!menuOpen);
              }}
            >
              Works
            </a>
          </li>
          <li>
            <a
              href="#testimonials"
              onClick={() => {
                setMenuOpen(!menuOpen);
              }}
            >
              Testimonials
            </a>
          </li>
          <li>
            <a
              href="#contact"
              onClick={() => {
                setMenuOpen(!menuOpen);
              }}
            >
              Contact
            </a>
          </li>
          {/* <li>
            <a
              href="#intro"
              onClick={() => {
                setMenuOpen(!menuOpen);
              }}
            >
              Home
            </a>
          </li> */}
        </ul>
      </div>
    </>
  );
}
